export default __webpack_public_path__ + "static/media/menu-06-more-w.e7ee9688.svg";